import { STORY_STATUS_STOPPED } from '../../../constants/stories';
import {
  IChangeStoryStatusResponse,
  IPublishStoryResponse,
  IStoriesFilters,
  IStoryData,
  IStoryListDataResponse,
  IUploadStoryFileResponse
} from '../../../interfaces/stories';
import { DEFAULT_CUSTOM_RESPONSE_MOCK } from '../../../mocks/customResponse';
import {
  UPLOAD_STORY_IMAGE_MOCK_RESPONSE,
  UPLOAD_STORY_VIDEO_MOCK_RESPONSE,
  MOCK_STORIES_LIST_RESPONSE,
  MOCK_STORY_DETAILS
} from '../../../mocks/stories';
import { GenericVoidFunction } from '../../../types/genericTypes';
import { StoryType, StoryTypeEnum } from '../../../types/stories';
import { HttpService } from '../../http/httpService';

export class Stories {
  static async uploadStoryFile(
    companyId: string,
    file: File,
    mediaType: StoryType,
    onUploadProgress: GenericVoidFunction
  ): Promise<IUploadStoryFileResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const MOCK_RESPONSE =
      mediaType === StoryTypeEnum.image ? UPLOAD_STORY_IMAGE_MOCK_RESPONSE : UPLOAD_STORY_VIDEO_MOCK_RESPONSE;

    const response = await HttpService.post<IUploadStoryFileResponse>(
      `stories/${companyId}/file`,
      formData,
      { onUploadProgress },
      MOCK_RESPONSE
    );
    return response.data;
  }

  static async createStory(
    companyId: string,
    mediaType: StoryType,
    contentUrl: string,
    title: string,
    startDate: string,
    endDate: string | null
  ): Promise<IPublishStoryResponse> {
    const body = {
      mediaType: mediaType,
      contentUrl: contentUrl,
      titleText: title,
      startDate: startDate,
      endDate: endDate
    };
    const response = await HttpService.post<IPublishStoryResponse>(
      `stories/${companyId}/create/story`,
      body,
      {},
      DEFAULT_CUSTOM_RESPONSE_MOCK
    );
    return response.data;
  }

  static async getStoriesList(
    companyId: string,
    pageNumber: number,
    pageSize: number,
    filters: IStoriesFilters,
    order: string
  ): Promise<IStoryListDataResponse> {
    const response = await HttpService.get<IStoryListDataResponse>(
      `stories/${companyId}/history`,
      {
        params: {
          pageNumber,
          pageSize,
          order,
          searchValue: filters.searchValue,
          type: filters.type.value,
          state: filters.status.status
        }
      },
      { data: MOCK_STORIES_LIST_RESPONSE }
    );
    return response.data;
  }

  static async getStoryDetail(companyId: string, storyId: string): Promise<IStoryData> {
    const response = await HttpService.get<IStoryData>(
      `stories/${companyId}/story/${storyId}`,
      {},
      { data: MOCK_STORY_DETAILS }
    );
    return response.data;
  }

  static async deleteStory(storyId: string): Promise<IChangeStoryStatusResponse> {
    const response = await HttpService.post<IChangeStoryStatusResponse>(
      `stories/update-status/${storyId}`,
      { status: STORY_STATUS_STOPPED },
      {},
      { data: MOCK_STORIES_LIST_RESPONSE }
    );
    return response.data;
  }
}

export default Stories;
